<section class="get-app">
  <h2 class="visually-hidden">{{ content.contact.h2 | translate }}</h2>
  <p>{{ content.contact.p | translate }}</p>
  <input type="tel" placeholder="+380 (xx) xxx-xx-xx" />
  <app-button [content]="content.contact.button"></app-button>
</section>
